class CfopConfiavelController extends AbstractController
  @$inject = ['$injector', 'cfopConfiavelService']

  constructor: ($injector, @cfopConfiavelService) ->
    super($injector)

    @loadingTracker = @promiseTracker()
    @submitTracker = @promiseTracker()
    @loadData()
    @cfop =
      numero: ''
      descricao: ''

  loadData: ->
    @loadingTracker.addPromise @cfopConfiavelService.getList(
      (data) =>
        @listOfCfops = data
    )

  salvar: (form, cfop) ->
    if form.$valid
      cfops = angular.copy @listOfCfops
      cfops.push(cfop)

      @submitTracker.addPromise @cfopConfiavelService.save(cfops,
        (data) =>
          @Alert.success("<strong>CFOP #{cfop.numero} adicionado</strong> com sucesso.")
          @listOfCfops = data.regra if data.regra?
          form.$setPristine()

          @cfop =
            numero: ''
            descricao: ''
      )

  remover: (cfop, index) ->
    cfops = angular.copy @listOfCfops
    cfops.remove(index)

    @Confirm.warning('Atenção', "Deseja realmente remover o CFOP <strong>#{cfop.numero}</strong>?", {
      Sim: =>
        @cfopConfiavelService.save(cfops,
          (data) =>
            @Alert.success("<strong>CFOP #{cfop.numero} removido</strong> com sucesso.")
            @listOfCfops = data.regra if data.regra?
          )
      Cancelar: null
    })



angular.module('eficienciaFiscalModule').controller('cfopConfiavelController', CfopConfiavelController)